import { render } from "./ControlloVociFattura.vue?vue&type=template&id=02c5962f"
import script from "./ControlloVociFattura.vue?vue&type=script&lang=js"
export * from "./ControlloVociFattura.vue?vue&type=script&lang=js"

import "./ControlloVociFattura.vue?vue&type=style&index=0&id=02c5962f&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__